import { render, staticRenderFns } from "./YearProductionResultComponent.vue?vue&type=template&id=4523886b&"
import script from "./YearProductionResultComponent.vue?vue&type=script&lang=js&"
export * from "./YearProductionResultComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports